export class ClosurePeriodSettingDeleteRequest {
    closurePeriodSettingId!: string

    constructor(closurePeriodSettingId: string) {
      this.closurePeriodSettingId = closurePeriodSettingId
    }
}
